// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MForm-components-MfVertNavLayout-MfVertNavLayout-module__box--b1xYs {
  height: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
  border-top: thin solid #f5f5f5;
  display: flex;
  gap: 24px;
}
.src-components-MForm-components-MfVertNavLayout-MfVertNavLayout-module__nav--t0XyX {
  width: 260px;
  height: 100%;
  overflow: auto;
}
.src-components-MForm-components-MfVertNavLayout-MfVertNavLayout-module__main--Tq3qp {
  flex: 1;
  height: 100%;
  overflow: auto;
}
.src-components-MForm-components-MfVertNavLayout-MfVertNavLayout-module__content--xHMXo {
  padding: 16px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
/*# sourceMappingURL=MfVertNavLayout.module.css.map */`, "",{"version":3,"sources":["webpack://./MfVertNavLayout.module.less","webpack://./src/components/MForm/components/MfVertNavLayout/MfVertNavLayout.module.less"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,SAAA;ACDF;ADGA;EACE,YAAA;EACA,YAAA;EACA,cAAA;ACDF;ADGA;EACE,OAAA;EACA,YAAA;EACA,cAAA;ACDF;ADGA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;ACDF;AACA,qDAAqD","sourcesContent":["@bkColor: #f5f5f5;\n\n.box {\n  height: 100%;\n  overflow: hidden;\n  background-color: @bkColor;\n  border-top: thin solid @bkColor;\n  display: flex;\n  gap: 24px;\n}\n.nav {\n  width: 260px;\n  height: 100%;\n  overflow: auto;\n}\n.main {\n  flex: 1;\n  height: 100%;\n  overflow: auto;\n}\n.content {\n  padding: 16px 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n",".box {\n  height: 100%;\n  overflow: hidden;\n  background-color: #f5f5f5;\n  border-top: thin solid #f5f5f5;\n  display: flex;\n  gap: 24px;\n}\n.nav {\n  width: 260px;\n  height: 100%;\n  overflow: auto;\n}\n.main {\n  flex: 1;\n  height: 100%;\n  overflow: auto;\n}\n.content {\n  padding: 16px 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n/*# sourceMappingURL=MfVertNavLayout.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-components-MForm-components-MfVertNavLayout-MfVertNavLayout-module__box--b1xYs`;
export var nav = `src-components-MForm-components-MfVertNavLayout-MfVertNavLayout-module__nav--t0XyX`;
export var main = `src-components-MForm-components-MfVertNavLayout-MfVertNavLayout-module__main--Tq3qp`;
export var content = `src-components-MForm-components-MfVertNavLayout-MfVertNavLayout-module__content--xHMXo`;
export default ___CSS_LOADER_EXPORT___;
